import { createApplePassWithQR, createApplePassWithLink } from '../../features/generate/services/appleWalletService';
import { createGooglePassWithQR, createGooglePassWithLink } from '../../features/generate/services/googleWalletService';

/**
 * Platform configuration for iOS and Android platforms
 * This abstraction allows for easy extension to new platforms in the future
 */
export const PLATFORM_CONFIG = {
    ios: {
        label: 'iOS',
        badgeClass: 'bg-blue-100 text-blue-800',
        passCreatorQR: createApplePassWithQR,
        passCreatorLink: createApplePassWithLink,
    },
    android: {
        label: 'Android',
        badgeClass: 'bg-green-100 text-green-800',
        passCreatorQR: createGooglePassWithQR,
        passCreatorLink: createGooglePassWithLink,
    },
    iphone: {
        // Alias for ios - normalize to 'ios' internally
        label: 'iOS',
        badgeClass: 'bg-blue-100 text-blue-800',
        passCreatorQR: createApplePassWithQR,
        passCreatorLink: createApplePassWithLink,
    },
};

/**
 * Get platform configuration for a given platform
 * @param {string} platform - Platform identifier ('ios', 'android', 'iphone')
 * @returns {Object} Platform configuration object
 */
export const getPlatformConfig = (platform) => {
    if (!platform) {
        return null;
    }
    return PLATFORM_CONFIG[platform] || PLATFORM_CONFIG.ios; // Default fallback to iOS
};

/**
 * Normalize platform identifier
 * Converts 'iphone' to 'ios' for consistency
 * @param {string} platform - Platform identifier
 * @returns {string} Normalized platform identifier
 */
export const normalizePlatform = (platform) => {
    if (platform === 'iphone') {
        return 'ios';
    }
    return platform;
};

/**
 * Get platform display label
 * @param {string} platform - Platform identifier
 * @returns {string} Display label for the platform
 */
export const getPlatformLabel = (platform) => {
    const config = getPlatformConfig(platform);
    return config ? config.label : platform || '—';
};

/**
 * Get platform badge CSS class
 * @param {string} platform - Platform identifier
 * @returns {string} CSS class for platform badge
 */
export const getPlatformBadgeClass = (platform) => {
    const config = getPlatformConfig(platform);
    return config ? config.badgeClass : 'bg-gray-100 text-gray-800';
};

